import { z } from 'zod';

import { parametersSchemaDefinition } from './custom-tool.schema';
import { postCallWorkflowSchema } from './workflow.schema';

export const reviewInputModeSchema = z.enum(['TRANSCRIPT', 'AUDIO', 'ORIGINAL_TRANSCRIPT']);

export const reviewConfigSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(2),
  prompt: z.string().min(10),
  max_retries: z.number().int().min(1).max(100).default(20),
  model_name: z.string().default('gemini-2.5-pro'),
  review_input_mode: reviewInputModeSchema.default('TRANSCRIPT'),
  temperature: z.number().min(0).max(2).default(0.2),
  is_default: z.boolean().default(false),
  notification_emails: z.array(z.string().email()).default([]),
  high_intent_emails: z.array(z.string().email()).default([]),
  response_fields_schema: parametersSchemaDefinition.optional(),
  review_date: z.string().date().nullable().optional(),
  // ISO 639-1 target language for transcript translation; null = off
  transcript_language: z.string().min(2).max(10).nullable().optional(),
  translation_model: z.string().default('gemini-2.5-flash'),
  post_call_workflow: postCallWorkflowSchema.nullable().optional(),
  created_at: z.date().or(z.string().datetime()),
  updated_at: z.date().or(z.string().datetime()),
});

export type ReviewConfig = z.infer<typeof reviewConfigSchema>;

export const createReviewConfigSchema = reviewConfigSchema
  .omit({ id: true, created_at: true, updated_at: true })
  .extend({
    name: z.string().min(2, 'Review config name must be at least 2 characters'),
    prompt: z.string().min(10, 'Prompt template should provide guidance'),
  });

export type CreateReviewConfigDto = z.infer<typeof createReviewConfigSchema>;

export const updateReviewConfigSchema = createReviewConfigSchema.partial();

export type UpdateReviewConfigDto = z.infer<typeof updateReviewConfigSchema>;
